<template>
  <span
    v-if="$parent.$options._componentTag === 'm-select'"
    :class="classes"
    class="mdc-floating-label"
    v-bind="$attrs"
  >
    <slot />
  </span>
  <label v-else :class="classes" class="mdc-floating-label" v-bind="$attrs">
    <slot />
  </label>
</template>

<script>
import { MDCFloatingLabel } from "@material/floating-label";

export default {
  inheritAttrs: false,
  props: {
    floatAbove: {
      type: Boolean,
      default: false
    },
    shake: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mdcFloatingLabel: undefined
    };
  },
  computed: {
    classes() {
      return {
        "mdc-floating-label--float-above": this.floatAbove,
        "mdc-floating-label--shake": this.shake
      };
    }
  },
  mounted() {
    this.mdcFloatingLabel = MDCFloatingLabel.attachTo(this.$el);
  },
  beforeDestroy() {
    this.mdcFloatingLabel.destroy();
  }
};
</script>
